import React from 'react';
import './Footer.css';
import { useLocalization } from '../../localization';

const MAILCHIMP_ACTION =
  'https://elpumarejo.us5.list-manage.com/subscribe/post?u=3b097d05db149cee847110218&amp;id=683f1a62c4';

const Footer: React.FC = () => {
  const { copy } = useLocalization();
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__inner">
        <div className="site-footer__meta">
          <p className="site-footer__copyright">
            &copy; {new Date().getFullYear()} El Pumarejo
          </p>
        </div>

        <div className="site-footer__socials" aria-label={copy.footer.socialLinks}>
          <a
            className="site-footer__link"
            href="https://instagram.com/elpumarejo"
            target="_blank"
            rel="noreferrer"
          >
            Instagram
          </a>
          <a
            className="site-footer__link"
            href="https://facebook.com/elpumarejo"
            target="_blank"
            rel="noreferrer"
          >
            Facebook
          </a>
          <a
            className="site-footer__link"
            href="https://tidal.com/artist/81847828/u"
            target="_blank"
            rel="noreferrer"
          >
            TIDAL
          </a>
        </div>

        <form
          action={MAILCHIMP_ACTION}
          className="site-footer__subscribe"
          method="post"
          name="mc-embedded-subscribe-form"
          target="_blank"
          noValidate
        >
          <label className="site-footer__subscribe-label" htmlFor="footer-email">
            {copy.footer.newsletter}
          </label>
          <div className="site-footer__subscribe-row">
            <input
              id="footer-email"
              className="site-footer__input"
              type="email"
              name="EMAIL"
              placeholder={copy.footer.emailPlaceholder}
              autoComplete="email"
              required
            />
            <input
              className="site-footer__button"
              type="submit"
              name="subscribe"
              value={copy.footer.subscribe}
            />
          </div>
          <div className="site-footer__honeypot" aria-hidden="true">
            <input
              tabIndex={-1}
              type="text"
              name="b_3b097d05db149cee847110218_683f1a62c4"
              defaultValue=""
            />
          </div>
        </form>
      </div>
    </footer>
  );
};

export default Footer;
